module.exports = __webpack_public_path__ + "media/10.50688499.mp3";